import script from "./houseIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./houseIndex.vue?vue&type=script&setup=true&lang=js"

import "./houseIndex.vue?vue&type=style&index=0&id=af1d5a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1d5a4a"]])

export default __exports__